(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured_Product"] && !Shopify.designMode) return;
  try {
    
/* drawer-cart logic (unchanged) */
(() => {
  const $sec = document.querySelector('#ProductDetails-{{ section.id }}');
  if(!$sec) return;

  $sec.addEventListener('submit', async e=>{
    const form = e.target.closest('form[action^="/cart/add"]'); if(!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]'), txt = btn.innerHTML;
    btn.disabled = true; btn.innerHTML = "{{ 'products.product.add_to_cart' | t }}…";
    try{
      await fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/x-www-form-urlencoded'},
        body:new URLSearchParams(new FormData(form))
      });
      document.dispatchEvent(new CustomEvent('theme:cart:open'));
    }finally{
      btn.disabled = false; btn.innerHTML = txt;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
